import { type RequestableApproverApiModel } from '@webapp/platform/approval-routing/data-access/api-models/RequestableApproverApiModel'
import { type RequestableApproverConstructor } from '@webapp/platform/approval-routing/entities/RequestableApprover'

export const mapRequestableApproverApiModel = (
  requestableApprover: RequestableApproverApiModel
): RequestableApproverConstructor => ({
  id: requestableApprover.id,
  userId: requestableApprover.user_id,
  threshold: Number(requestableApprover.threshold),
  email: requestableApprover.user.email,
  firstName: requestableApprover.user.firstName,
  lastName: requestableApprover.user.lastName,
  profileImage: requestableApprover.user.profile_image,
})
